"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var AnalyticEvents_1 = __importDefault(require("../../../utils/AnalyticEvents"));
var styles_1 = require("./v3/styles");
var utils_1 = require("./v3/utils");
var Pick3Ticket = function (_a) {
    var ticket = _a.ticket, updateTicket = _a.updateTicket, theme = _a.theme, updateBetType = _a.updateBetType, _b = _a.isNewVersion, isNewVersion = _b === void 0 ? false : _b, gameName = _a.gameName, errors = _a.errors, ticketIndex = _a.ticketIndex;
    var classes = (0, styles_1.styles)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var updateNumber = function (value, numberIndex) {
        var newValue = value ? Number(value) : null;
        if (newValue === null || newValue <= 9) {
            updateTicket(__assign(__assign({}, ticket), { numbers: ticket.numbers.map(function (number, index) {
                    return index === numberIndex ? newValue : number;
                }) }));
        }
    };
    var onNumberChange = function (event, index) {
        var newValue = event.target.value;
        updateNumber(newValue, index);
        if (newValue.length === 1 && ticket.numbers.length > index + 1) {
            var numberInputs = Object.values(event.target.closest(".".concat(classes.ticketContainer)).getElementsByTagName('input'));
            if (numberInputs.length === 0) {
                return;
            }
            var firstEmptyInput = numberInputs.find(function (el) { return el.value === ''; });
            if (!firstEmptyInput) {
                return;
            }
            firstEmptyInput.focus();
        }
    };
    var onBetTypeChange = function (event) {
        var newBetTypeKey = event.target.value;
        var numberCount = 3;
        if (newBetTypeKey === utils_1.BetType.FIRST_DIGIT) {
            numberCount = 1;
        }
        else if (newBetTypeKey === utils_1.BetType.BACK_PAIR || newBetTypeKey === utils_1.BetType.FRONT_PAIR) {
            numberCount = 2;
        }
        var newTicket = __assign(__assign({}, ticket), { numbers: getNewNumbers(ticket.numbers, numberCount) });
        updateTicket(newTicket);
        updateBetType(newBetTypeKey);
    };
    var getNewNumbers = function (numbers, numberCount) {
        if (numbers.length < numberCount) {
            var diff = numberCount - numbers.length;
            var nullArray = Array(diff).fill(null);
            numbers.push.apply(numbers, nullArray);
        }
        else if (numbers.length > numberCount) {
            numbers.splice(numberCount);
        }
        return numbers;
    };
    return (react_1.default.createElement("div", { className: classes.ticketContainer },
        react_1.default.createElement("div", { className: classes.ticketLabels },
            react_1.default.createElement(core_1.Typography, { variant: "body2", component: "span", className: classes.inputLabel }, "Ticket ".concat(ticketIndex + 1, " Numbers"))),
        react_1.default.createElement(core_1.FormControl, { fullWidth: true },
            react_1.default.createElement("div", { className: classes.betType },
                react_1.default.createElement(core_1.InputLabel, { className: classes.selectInputLabel, shrink: false, htmlFor: "bet-select-".concat(ticketIndex + 1) }, t('numberChecker.betType')),
                react_1.default.createElement(core_1.Select, { id: "bet-select-".concat(ticketIndex + 1), className: classes.formInput, value: ticket.betType, onChange: onBetTypeChange, autoComplete: "off" }, Object.values(utils_1.BetType).map(function (betType) { return (react_1.default.createElement(core_1.MenuItem, { key: betType, value: betType }, betType)); })))),
        ticket.numbers.map(function (number, index) {
            var _a, _b;
            var onChange = function (event) { return onNumberChange(event, index); };
            var onBlur = function () {
                var _a;
                var analyticsevent = (_a = window === null || window === void 0 ? void 0 : window.analyticsEventMapping) === null || _a === void 0 ? void 0 : _a['AE0118'];
                if (!!analyticsevent) {
                    AnalyticEvents_1.default.logEvent('AE0118', __assign(__assign({}, analyticsevent), { eventCategory: analyticsevent.eventCategory + '_' + (gameName === null || gameName === void 0 ? void 0 : gameName.toLowerCase().replace(' ', '_')) }));
                }
            };
            var handleKeyDown = function (event) {
                if (event.keyCode === 32) {
                    event.preventDefault();
                }
            };
            var getIndex = function (num) {
                switch (num) {
                    case 1:
                        return '1st*';
                    case 2:
                        return '2nd*';
                    case 3:
                        return '3rd*';
                    default:
                        return '1st*';
                }
            };
            var hasError = ((_a = errors[ticketIndex]) === null || _a === void 0 ? void 0 : _a.find(function (e) { return (e === null || e === void 0 ? void 0 : e.key) === 0; })) ||
                ((_b = errors[ticketIndex]) === null || _b === void 0 ? void 0 : _b.find(function (e) { return (e === null || e === void 0 ? void 0 : e.key) === index + 1; }));
            return (react_1.default.createElement(core_1.Box, { display: "flex", flexDirection: "column", key: "".concat(ticketIndex + 1, "-").concat(index + 1) },
                react_1.default.createElement(core_1.FormControl, { fullWidth: true },
                    react_1.default.createElement(core_1.InputLabel, { shrink: false, className: hasError ? classes.indexLabelError : classes.indexLabelUpdated, htmlFor: "ticket-input-".concat(ticketIndex + 1, "-").concat(index + 1) },
                        react_1.default.createElement(core_1.Typography, { variant: 'srOnly' }, "Ticket ".concat(ticketIndex + 1, ", ")),
                        getIndex(index + 1)),
                    react_1.default.createElement(core_1.Input, { id: "ticket-input-".concat(ticketIndex + 1, "-").concat(index + 1), className: (0, classnames_1.default)([
                            classes.numberInput,
                            hasError ? classes.numberErrorInput : undefined,
                            isNewVersion ? classes.numberInputUpdated : ''
                        ]), value: number !== undefined && number !== null ? number === null || number === void 0 ? void 0 : number.toString() : '', key: "".concat(ticketIndex + 1, "-").concat(index + 1), onChange: onChange, onBlur: onBlur, onKeyDown: handleKeyDown, classes: { input: classes.centerText }, autoComplete: 'off', inputProps: {
                            'aria-required': true
                        } }))));
        })));
};
exports.default = Pick3Ticket;
//# sourceMappingURL=Pick3Ticket.js.map